import React, { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';

export default function Loader(props) {
    const { show, textToShow } = props;
    const [dots, setDots] = useState('...');

    useEffect(() => {
        const addDots = () => {
            setDots((prevDots) => (prevDots.length < 3 ? prevDots + '.' : ''));
        };
        const interval = setInterval(addDots, 200);
        return () => clearInterval(interval);
    }, []);

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: 9999, backdropFilter: 'blur(1px)' }}
            open={show}
        >
            {props.children ? (
                props.children
            ) : (
                <>
                    <div className="loader"></div>
                    <div style={{ position: 'fixed', top: '70%', left: '50%', transform: 'translateX(-50%)', textAlign: 'center' }}>
                        {textToShow && <span>{textToShow}</span>}
                        <span>{dots}</span>
                    </div>
                </>
            )}
        </Backdrop>
    );
}

